export default function initCopyContent() {
  const isPresent = document.querySelectorAll("[data-copy-content]");

  if (!isPresent.length) {
    return;
  }

  // JavaScript Function
  document.addEventListener("click", function (event) {
    // Check if the clicked element has a data-copy-content attribute
    if (event.target.hasAttribute("data-copy-content")) {
      // Get the value of data-copy-content attribute
      const copyContent = event.target.getAttribute("data-copy-content");

      // Find the element with the matching data-copy-target attribute
      const targetElement = document.querySelector(
        `[data-copy-target="${copyContent}"]`
      );

      if (targetElement) {
        // Copy the text content of the target element to the clipboard
        const textToCopy = targetElement.textContent || targetElement.innerText;

        // Create a temporary textarea element to copy the content
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);

        // Select the content and copy it to clipboard
        tempTextArea.select();
        document.execCommand("copy");

        // Remove the temporary textarea element
        document.body.removeChild(tempTextArea);

        // Add the "active" class to the clicked button
        event.target.classList.add("active");

        // Remove the "active" class after 500 milliseconds
        setTimeout(() => {
          event.target.classList.remove("active");
        }, 2000);
      } else {
        console.error(
          `Element with data-copy-target="${copyContent}" not found.`
        );
      }
    }
  });
}
